export enum MobileOS {
  Android = "Android",
  iOS = "iOS",
}

export type OS = "Android" | "iOS";
